import { SearchOurProperties } from '@tenants';

export const searchOurPropertiesConfig: SearchOurProperties = {
  title: {
    __html: 'Search Our<br />Properties',
  },
  linkText: 'Search Properties',
  linkPath: '/listings',
  imageCarousel: [
    '/next/assets/images/exp-commercial/commercial-property-example-1.jpg',
    '/next/assets/images/exp-commercial/commercial-property-example-2.jpg',
    '/next/assets/images/exp-commercial/commercial-property-example-3.jpg',
    '/next/assets/images/exp-commercial/commercial-property-example-4.jpg',
    '/next/assets/images/exp-commercial/commercial-property-example-5.jpg',
  ],
};